import { IntegrationProviderDTO } from '@/modules/common/types/dto/response/integration-response';

/**
 * Whether an entity's connected-integrations list includes QuickBooks — the one link the
 * generate screens need before an invoice or bill can be created for it.
 */
export const hasQuickBooksIntegration = (
  connectedIntegrations: IntegrationProviderDTO[] | undefined
): boolean => !!connectedIntegrations?.includes(IntegrationProviderDTO.QUICK_BOOKS);

/**
 * Sub-rows of the generate tables (members, lines, the add-line button) carry a `type`
 * discriminator; top-level project / member rows do not. Used to opt sub-rows into the
 * table's grow-in / shrink-out animation.
 */
export const isGenerateSubRow = <T>(row: T): boolean =>
  typeof row === 'object' && row !== null && 'type' in row;
